import {fileFormatFamilyRuleDefaults} from './defaults';
import {FileFormatFamilyRule} from './types';

type GetFileFormatFamilyRuleParams = {
	fileFormatFamily: string;
};

export const createFileFormatFamilyRule = ({
	fileFormatFamily,
}: GetFileFormatFamilyRuleParams): FileFormatFamilyRule => ({
	...fileFormatFamilyRuleDefaults,
	elementValue1: fileFormatFamily,
});

export default createFileFormatFamilyRule;
